const { newrelic } = window

const reportPdpABTest = () => {
  const cookieValue = document.cookie
    .split('; ')
    .find(row => row.startsWith('PDP_Test_Group_1='))
    ?.split('=')[1]

  const BRAND = process.env.BRAND || 'ARGOS'
  const isTestGroup = cookieValue && cookieValue === '2'

  // window.__data is checking for 404 to exlude from AB test
  if (typeof newrelic === 'object' && BRAND === 'ARGOS' && !window?.__data?.productStore?.meta?.errorCode) {
    const testGroupLabel = isTestGroup ? 'Variant' : 'Control'
    newrelic.setCustomAttribute('pdpABTest', testGroupLabel)
  }
}

export default reportPdpABTest
